import { cssVariables } from '@mindtickle/styles';

export const NAVIGATION_VIEW_STATE_KEY = 'mt_nav_state';
export const TRANSITION_DURATION_MS = 200;
export const POPOVER_CONTENT_DELAY = 1;
export const POPOVER_CONTENT_OFFSET_X_EXPANDED = 8;
export const POPOVER_CONTENT_OFFSET_X_COLLAPSED = -2;
export const POPOVER_CONTENT_OFFSET_Y = -20;
export const NAVIGATION_CSS_VARIABLES = {
  NAV_CONTAINER_ACTIVE_ICON_COLOR: cssVariables.BRAND_COLOR_500,
  NAV_CONTAINER_ACTIVE_BG_COLOR: cssVariables.BRAND_COLOR_100,
};
